export enum Modals {
  PaymentModal = 'payment-modal',
  TariffsModal = 'tariffs-modal',
}
